import React from 'react';

import {ButtonAdd} from '@appComponents/ButtonCollection';
import Link from '@appComponents/Link';
import {Authorization} from '@appComponents/Authorization';
import {SPIIDEO_STADIUM_MAPPING} from '@constants/resources';
import {SECURITY_PRIVILEGES_CREATE} from '@constants/variables';

const SpiideoVenuesIndexButtons = () => {
    const authorizationObject = {[SPIIDEO_STADIUM_MAPPING]: SECURITY_PRIVILEGES_CREATE};

    return (
        <div className='content__buttons'>
            <Authorization authorization={authorizationObject}>
                <Link name='spiideoMappings.venuesAdd'>
                    <ButtonAdd>{'Add new venue mapping'}</ButtonAdd>
                </Link>
            </Authorization>
        </div>
    );
};

export default SpiideoVenuesIndexButtons;
